import script from "./day-off-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./day-off-select.vue?vue&type=script&lang=ts&setup=true"

import "./day-off-select.vue?vue&type=style&index=0&id=9f1cabb8&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f1cabb8"]])

export default __exports__